// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"0f194269","242":"18d10e55","337":"0f194269","476":"283f06bc","706":"97e094f9","738":"acac313d","882":"97e094f9","965":"9e2ffe27","993":"0f194269"}[chunkId] + ".chunk.css";
};